/*
import {
  hf,
  ht,
  cr,
  useCfmz,
  useLdrz,
  a,
  BtnC,
  GridC,
} from 'lib';
*/
import * as cr from './_cr';
import * as _hm from './_hf';
import * as ht from './_ht';
import { useCfmz } from "./_csMdlCfm";
import * as GridC from "./_cccGridC";
import { useLdrz } from "./_csLdr";
import * as BtnC from "./_cccBtnC";


export const N = (pz: ht.btnCttCz) => {
  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();
  return (
    cr.c(GridC.N, {
      key: 'BtnCtt.root',
      abtType: 'barBtnViewCmnz',
      lineCs: [{
        cellCs: 
        (pz.sPz.crt.vsn > 0) ?
        [
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -10,
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: '最新の内容に戻る',
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      vsn: -1,
                    })
                  }
                },
              })
            ]
          }
        ]
        :
        [
          pz.sPz.crt.phs == 'crt' ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -20,
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.crtz.back,
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      steps: [0],
                    })
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'crt' ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -30,
                abtType: 'nextCmnz',
                //boxStlz: a(`sc/${pz.cz.sc ?? 'lt7'}`),
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.crtz.next,
                  },
                },
                pslPtyz: {
                  onPress: async () => {
                    if (pz.cz.ugdAsync) {
                      _sLdrz.show();
                      const _dz = await pz.cz.ugdAsync();
                      _sLdrz.hide();
                      if (_hm.f(_dz)) {
                        pz.sPz.set({
                          ... _dz,
                          phs: 'dpy'
                        }) // udgAsync で sPz.set すると更新が正しく行われない
                      }
                    }
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'dpy' ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -40,
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.dpyz.back,
                  },
                },
                pslPtyz: {
                  onPress: pz.onBackPrs ? pz.onBackPrs : () => {
//_hm.l(`_ccmBtnCttC 122: here`)
                    pz.sPz.set({
                      steps: [0],
                    })
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'dpy' && _hm.f(pz.cz.lblz.btnz.cttz.dpyz.next)?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -50,
                abtType: 'nextCmnz',
                //boxStlz: a(`sc/${pz.cz.sc ?? 'lt7'}`),
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.dpyz.next,
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      phs: 'udt',
                    });
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'dpy' && pz.cz.dltAsync?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -60,
//                abtType: 'dltCmnz',
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.dpyz.dlt,
                  },
                },
                pslPtyz: {
                  onPress: async () => {
                    _sCfmz.show({
                      pfx: '削除して良いですか？',
                      onPrs: async (_n: ht.n) => {
                        if (_n == 1) {
                          _sLdrz.show();
                          if (pz.cz.dltAsync) await pz.cz.dltAsync();
                          _sLdrz.hide();
                          pz.sPz.set({
                            steps: [0],
                            phs: 'dpy'
                          })
                        }
                      }
                    })
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'udt' ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -70,
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.udtz.back,
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      phs: 'dpy'
                    })
                  }
                },
              })
            ]
          }
          : null,
          pz.sPz.crt.phs == 'udt' ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -80,
                abtType: 'nextCmnz',
                //boxStlz: a(`sc/${pz.cz.sc ?? 'lt7'}`),
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.cttz.udtz.next,
                  },
                },
                pslPtyz: {
                  onPress: async () => {
                    //hf.l(`_btnCttC 185: here`)
                    if (pz.cz.ugdAsync) {
                      //hf.l(`_btnCttC 194: here`)
                      _sLdrz.show();
                      //hf.l(`_btnCttC 196: here`)
                      const _dz = await pz.cz.ugdAsync();
                      //hf.l(`_btnCttC 198: ${hf.s(_dz)}`)
                      _sLdrz.hide();
                      //hf.l(`_btnCttC 200: here`)
                      if (_hm.f(_dz)) {
                        //hf.l(`_btnCttC 202: here`)
                        pz.sPz.set({
                          ... _dz,
                          phs: 'dpy'
                        })
                      }
                    }
                  }
                },
              })

            ],
          }
          : null,
        ],
      }]
    })
  );
};